import { Pipe, PipeTransform } from '@angular/core';
import { IpCurrencyService } from 'src/app/invopay/services/ip-currency.service';
import { AmountFormatPipe } from '../Utils/amount-format-pipe.pipe';
import { CurrencySymbolPipe } from '../Utils/currency-simbol-pipe';

@Pipe({
  name: 'amountCurrencyCode'
})
export class AmountCurrencyCodePipe implements PipeTransform {

  constructor(
    private readonly currencySymbolPipe: CurrencySymbolPipe,
    private readonly amountPipe: AmountFormatPipe,
    private readonly currencyService: IpCurrencyService
  ) { }

  transform(value: string | number | null, currencyCode: string | null): string | null {
    if (value == null || currencyCode == null) {
      return null;
    }
    const currencySymbol = this.currencySymbolPipe.transform(currencyCode);
    const formattedAmount = this.amountPipe.transform(value, true, currencySymbol, currencyCode);
    return formattedAmount;
  }

}
